export default function Footer() {
  return (
    <footer id="contact" className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-12 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/f60e38fb56feb0430ca9dd1939339c52/ccebb508c891aa10f301f784384056e8.png" 
              alt="The Owner Press" 
              className="h-8 md:h-10 w-auto mb-4 md:mb-6 brightness-0 invert"
            />
            <p className="text-sm md:text-base text-gray-400 leading-relaxed mb-4 md:mb-6 max-w-md">
              Empowering independent journalists with the highest ethical standards. Part of The Owner School Ecosystem.
            </p>
            <div className="flex items-center gap-3 md:gap-4">
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base md:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">Quick Links</h3>
            <ul className="space-y-2 md:space-y-3">
              <li><a href="#about" className="text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#services" className="text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">Services</a></li>
              <li><a href="#truth-report" className="text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">Truth Report</a></li>
              <li><a href="#network" className="text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">Our Network</a></li>
              <li><a href="#live-site" className="text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">Live Site</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">Contact Us</h3>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-mail-line text-green-500 mt-1 text-sm md:text-base"></i>
                <a href="mailto:info@theownerpress.com" className="text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer break-all">info@theownerpress.com</a>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-phone-line text-green-500 mt-1 text-sm md:text-base"></i>
                <span className="text-sm text-gray-400">Available 24/7</span>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-map-pin-line text-green-500 mt-1 text-sm md:text-base"></i>
                <span className="text-sm text-gray-400">Decentralized Network</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
            <p className="text-xs md:text-sm text-gray-400 text-center md:text-left">
              © 2024 The Owner Press. All rights reserved. Part of The Owner School Ecosystem.
            </p>
            <div className="flex items-center gap-4 md:gap-6 flex-wrap justify-center">
              <a href="#" className="text-xs md:text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-xs md:text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-green-500 transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}